$(window).on('load', function () {

    if ($(".SBanner .Spicture map").length > 0) {
        $(".SBanner").each(function () {
            if ($(this).find(".Spicture map").length > 0) {
                var imgWidth = $(this).find(".carousel-item.active").find("img").width();

                $(this).find(".Spicture map area").each(function () {
                    var ow = $(this).parent("map").data("ow");
                    var ratio = ow / imgWidth;

                    var thisCoords = $(this).attr("coords");
                    var res = thisCoords.split(",");

                    for (var item in res) {
                        res[item] = parseInt(res[item] / ratio);
                    }

                    $(this).attr("coords", res);
                });
            }
        });

        $(".SBanner .Spicture img").each(function () {
            if (isMobileResolution()) {
                $(this).attr("usemap", $(this).attr("usemap") + "-m");
            }
            else {
                $(this).attr("usemap", $(this).attr("usemap") + "-d");
            }
        });
    }
    
    $(document).on("swiperight", ".SBanner", function () {
        $(this).carousel('prev');
    });

    $(document).on("swipeleft", ".SBanner", function () {
        $(this).carousel('next');
    });

    //$('.SBanner').carousel({
    //    interval: 2000,
    //    keyboard: true,
    //    pause: 'hover'
    //});
});